<template>
  <div class="home-about-us">
    <div class="flex-cover wrap">
      <div class="left">
        <h2>Greeting from<br />a Representative<br />at Great Help</h2>
        <p class="sub-title">代表者あいさつ</p>
      </div>
      <div class="right">
        <p class="text">
          株式会社グレイトヘルプのホームページをご覧いただき、ありがとうございます。当社はウェブのマーケティングと媒体制作を強みに、事業主様の支援を行っています。ウェブ・ITは、年々と高度化し、また、事業への影響範囲が大きくなってきています。そのため、ウェブ・ITの技術の有無によって事業のパフォーマンスに大きな影響が出る半面、多くの人にとって「わかりづらい」「難しい」と感じるのがウェブ・ITだという問題があります。ウェブ・ITを高い技術で全面的にサポートすることでクライアントは自身の事業に注力できる、そんな価値を提供していきます。
        </p>
        <div class="representative-name-box">
          <div class="representative-name-description">代表者取締役</div>
          <div class="representative-name">小関 貴久</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import UiTable from "@/components/Ui/Table.vue";
// import UiSliderBox from "@/components/Ui/SliderBox.vue";
export default {
  name: "home-top-class-website",
  components: {
    // UiTable,
    // UiSliderBox,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.flex-cover {
  .left {
    width: 50%;

    @media screen and (max-width: 767px) {
      width: 100%;
    }

    .text {
      margin-top: 70px;
    }
  }

  .right {
    width: 48%;
    // padding: 50px;
    // background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 767px) {
      width: 100%;
      margin-top: 30px;
      padding: 20px;
    }

    img {
      width: 70%;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 20px;
    }

    .name {
      font-size: 22px;

      .daihyo {
        font-size: 16px;
        margin-right: 10px;
      }
    }

    .text {
      font-size: 16px;
      // margin-top: 20px;
    }

    .representative-name-box {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;

      @media screen and (max-width: 767px) {
        margin-top: 1em;
      }

      .representative-name-description {
        font-size: 16px;
        margin-right: 1em;
      }

      .representative-name {
        font-size: 28px;
        font-weight: bold;
      }
    }
  }
}

.slider {
  margin-top: 100px;
}
</style>
